export enum SchoolActionTypes {
    SCHOOL_CHANGE = "SCHOOL_CHANGE",
}
